import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

//Permite el acceso a las rutas solo si el usuario no esta logueado.
export const UnProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return children;
};
